import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ChartComponent} from "ng-apexcharts";
import {endOfMonth, endOfWeek, endOfYear, startOfMonth, startOfWeek, startOfYear} from "date-fns";
import {ApiService} from "../../../services/api.service";

@Component({
  selector: 'app-heat-map',
  templateUrl: './heat-map.component.html',
  styleUrls: ['./heat-map.component.scss']
})
export class HeatMapComponent implements OnInit, OnChanges {

  @ViewChild("chart", { static: false }) chart: ChartComponent;
  @Input() filterID: string | undefined;
  @Input() filterBy: 'brand' | 'campaign' | undefined;
  @Input() activityScope : string;

  public chartOptions: any;

  data: any;

  constructor(private api: ApiService, public ref: ChangeDetectorRef) {
  }

  ngOnInit(): void {

    this.api.apiPost('core/reporting/donations/heatmap', {
      [this.filterBy + '_id'] : this.filterID,
    }).then((res)=>{
      this.data = res;
      this.initChart();
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateChart(changes)
  }

  updateChart(changes:SimpleChanges){

  }

  initChart(){

    this.chartOptions = {
      colors: ['#1c2138'],
      series: [
        {
          name: 'Sunday',
          data: this.data.Sunday
        },
        {
          name: 'Saturday',
          data: this.data.Saturday
        },
        {
          name: 'Friday',
          data: this.data.Friday
        },
        {
          name: 'Thursday',
          data: this.data.Thursday
        },
        {
          name: 'Wednesday',
          data: this.data.Wednesday
        },
        {
          name: 'Tuesday',
          data: this.data.Tuesday
        },
        {
          name: 'Monday',
          data: this.data.Monday
        },

      ],
      chart: {
        fontFamily: 'Poppins, sans-serif',
        type: "heatmap",
        height: '300',
        width: '100%',
        padding: 0,
        selection:{
          enabled: false
        },
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      xaxis:{
        labels:{
          style:{
            colors: '#212a4b',
            fontSize: '12px',
            fontWeight: 600
          },
        }
      },
      yaxis:{
        labels:{
          style:{
            colors: '#212a4b',
            fontSize: '14px',
            fontWeight: 600
          },
        }
      },
      stroke: {
        colors: ['#f5f5f5']
      },
      dataLabels: {
        enabled: false
      },

    };


    this.ref.detectChanges();
  }

}
